import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1aa1033f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "workspace-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202510/7b91564f0f304d188d7a7b8c834405e6.png",
  class: "hand-icon",
  alt: ""
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "workspace-title"
}, " 开启智慧教学之旅 ", -1));

const _hoisted_4 = {
  class: "workspace-list"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "name"
};
import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    zhsRole: {
      type: Number,
      default: null
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },

  setup(__props) {
    const props = __props;
    const menuList = [{
      name: '学生',
      icon: 'https://prod-polymas.oss-cn-hangzhou.aliyuncs.com/polymas-basic-resource/YkX3ld/JaCT4n/693a2fc2e4b0cb4791307738.png',
      path: 'https://onlineweb.zhihuishu.com/onlineMuster/teacherIndex'
    }, {
      name: '教师',
      icon: 'https://prod-polymas.oss-cn-hangzhou.aliyuncs.com/polymas-basic-resource/YkX3ld/JaCT4n/693a2fc5e4b0cb4791307739.png',
      path: 'https://onlineweb.zhihuishu.com/onlineMuster/teacherIndex'
    }, {
      name: '同等学力',
      icon: 'https://prod-polymas.oss-cn-hangzhou.aliyuncs.com/polymas-basic-resource/YkX3ld/JaCT4n/693a2fbee4b093ffe4bbbc1f.png',
      path: 'https://onlineweb.zhihuishu.com/onlineMuster/teacherIndex'
    }, {
      name: '师承人员',
      icon: 'https://prod-polymas.oss-cn-hangzhou.aliyuncs.com/polymas-basic-resource/YkX3ld/JaCT4n/693a2fb9e4b093ffe4bbbc1e.png',
      path: 'https://onlineweb.zhihuishu.com/onlineMuster/teacherIndex'
    }];

    const goLogin = () => {
      if (!props.userInfo) {
        handleLogin();
      } else {
        window.open('https://onlineweb.zhihuishu.com/onlineMuster/teacherIndex');
      }
    };

    const handleClick = () => {
      if (props.zhsRole === 3 || props.zhsRole === 0) {
        window.open('https://onlineweb.zhihuishu.com/onlinestuh5');
      } else {
        window.open('https://onlineweb.zhihuishu.com/onlineMuster/teacherIndex');
      }
    };

    return (_ctx, _cache) => {
      const _component_Right = _resolveComponent("Right");

      const _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "workspace-box",
        style: _normalizeStyle({
          height: __props.userInfo ? '292px' : '258px'
        })
      }, [_hoisted_2, _hoisted_3, __props.userInfo ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "go-manage",
        onClick: handleClick
      }, [_createTextVNode(_toDisplayString(__props.zhsRole === 3 || __props.zhsRole === 0 ? '去学习' : '去管理'), 1), _createVNode(_component_el_icon, {
        size: "16px"
      }, {
        default: _withCtx(() => [_createVNode(_component_Right)]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item, index) => {
        return _createElementVNode("a", {
          class: "workspace-item",
          key: index,
          onClick: goLogin
        }, [_createElementVNode("img", {
          src: item.icon,
          class: "icon",
          alt: ""
        }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)]);
      }), 64))])], 4)]);
    };
  }

};